import styled from "styled-components";
import {
  mediaMinWidth,
  mediaMaxWidth,
} from "../../../utils/mediaQueriesTemplate";
import zIndexTypes from "../../../../theme/zIndexTypes";

export const Wrapper = styled.div`
  min-height: 56px;
  background: #402680;
  position: fixed;
  top: 60px;
  margin-left: ${(props) => (props.noMargin ? "0" : "60px")};
  width: ${(props) => (props.fullWidth ? "100%" : "calc(100% - 60px)")};
  z-index: ${zIndexTypes.actionBar};
  box-shadow: 0px 1px 0px #bdbdbd;
  transition: 0.3s ease-in-out;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding-top: ${(props) => (props.isIE ? "15px" : "unset")};
  transition: 0.2s ease-in-out;
  text-transform: ${(props) => props.capitalize && "capitalize"};

  .react-router-link .react-router-button {
    top: 12px;
  }

  ${mediaMaxWidth.tablet`
    margin-left: 0;
    width: 100%;
    padding-top: ${(props) => (props.isIE ? "5px" : "unset")};

    &.downScroll {
      top: 0;
    }

    &.tab-nav-action-bar {
      top: 0;
    }
  `}
`;

export const BackLink = styled.a`
  position: absolute;
  left: 20px;
  font-size: 1em;
  font-weight: 500;
  color: #fff !important;
  letter-spacing: 0.03em;
  cursor: pointer;
  transition: 0.1s ease-in-out;

  &:before {
    content: "<";
    position: relative;
    top: -2px;
    left: -5px;
  }

  &:hover {
    color: #79D9D9 !important;
  }

  ${mediaMaxWidth.tablet`
    display: none;
  `}
`;

export const Title = styled.h1`
  color: #fff;
  margin-top: 0;
  font-family: Komet;
  font-weight: bold;
  font-size: 1.25em;
  letter-spacing: 0.015em;
  width: 80vw;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: center;
  text-transform: capitalize;
  position: relative;

  &::after {
    content: "beta";
    display: ${(props) => (props.betaBadge ? "inline-block" : "none")};
    background-color: #79D9D9;
    color: #fff;
    border-radius: 25px;
    padding: 2px 5px;
    font-size: 0.5em;
    text-transform: uppercase;
    position: absolute;
    top: 0;
    margin-left: 5px;
  }

  ${mediaMaxWidth.smallDesktop`
    width: 70vw;
  `}

  ${mediaMaxWidth.tablet`
    display: none;
  `}
`;

export const MobileTitle = styled.h1`
  color: #fff;
  margin-top: 0;
  font-family: Komet;
  font-weight: bold;
  font-size: 1em;
  letter-spacing: 0.015em;
  width: 72vw;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: center;
  text-transform: capitalize;
  position: relative;

  &::after {
    content: "beta";
    display: ${(props) => (props.betaBadge ? "inline-block" : "none")};
    background-color: #79D9D9;
    color: #fff;
    border-radius: 25px;
    padding: 2px 5px;
    font-size: 0.45em;
    text-transform: uppercase;
    position: absolute;
    top: 0;
    margin-left: 5px;
  }

  ${mediaMinWidth.tablet`
    display: none;
  `}
`;

export const Subtitle = styled.div`
  color: #fff;
  width: 72vw;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: center;
  font-size: 0.9em;

  ${mediaMinWidth.tablet`
    display: none;
  `}
`;

export const MobileBackButton = styled.div`
  position: absolute;
  height: 32px;
  width: 32px;
  border-radius: 50%;
  background-color: #fff;
  left: 10px;
  top: 12px;

  &:after {
    content: "\f060";
    font-family: FontAwesome;
    color: #333;
    font-size: 1.4em;
    position: relative;
    left: 5px;
  }

  ${mediaMinWidth.tablet`
    display: none;
  `}
`;

export const Spinner = styled.img`
  height: 30px;
`;
